import { FunctionComponent, ReactNode } from 'react';

interface ExternalLinkProps {
    url: string;
    title?: string | null;
    className?: string;
    children: ReactNode;
}

const ExternalLink: FunctionComponent<ExternalLinkProps> = ({
    url,
    title,
    className,
    children,
}) => (
    <a
        href={url}
        target="_blank"
        rel="nofollow noopener noreferrer"
        {...(title ? { title } : {})}
        className={className}
    >
        {children}
    </a>
);

export default ExternalLink;
